/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Combine_TitleInputs */

const en_pc_tut_combine_title = /** @type {(inputs: Pc_Tut_Combine_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combine, extract and split PDFs`)
};

const zh_pc_tut_combine_title = /** @type {(inputs: Pc_Tut_Combine_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并、提取和拆分 PDF`)
};

/**
* | output |
* | --- |
* | "Combine, extract and split PDFs" |
*
* @param {Pc_Tut_Combine_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_combine_title = /** @type {((inputs?: Pc_Tut_Combine_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Combine_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_combine_title(inputs)
	return zh_pc_tut_combine_title(inputs)
});
export { pc_tut_combine_title as "pc.tut.combine.title" }